module.exports = __webpack_public_path__ + "img/paihang_bg.38f50993.png";